//Helpers
import { replaceNonAlphaNumericChars } from "../../../helpers";

export function getLocationName(event: any) {
  return replaceNonAlphaNumericChars(event.target.attributes.name.value);
}
